/* eslint-disable no-underscore-dangle */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  getEnterpriseSelected,
  getVisibilityPermission,
} from '@orientaction/components/Admin/Test/utils';
import { Company, TestService } from '@orientaction/services';
import { getFromLS } from '@orientaction/utils';
import { createContext, useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { RecommendedTest, RecommendedTestDrawerState } from '../interfaces/RecommendedTest';

const initialState = {
  test: {
    id: '',
    title: '',
    description: '',
    image: '',
    thumbnail: '',
    useGlobalTimer: false,
    globalTimer: '',
    stockageMode: { value: 1, label: 'Données stockées' },
    visibilityPermission: null,
    enterpriseSelected: null,
    isAllEnterpriseSelected: false,
    time: undefined,
    diagram: {
      id: 1,
      type: 'Diagramme en secteur - simple',
    },
    univers: null,
    minValueAg: '',
    maxValueAg: '',
  },
  variables: [],
  questions: [],
  toDeleteQuestionsIds: [],
  toDeleteVariablesIds: [],
  toDeleteResponsesIds: [],
  finalText: { id: '', title: '', description: '' },
  recommendedTests: [] as RecommendedTest[],
  recommendedTestDrawer: {
    open: false,
    searchQuery: '',
    searchResults: [],
    selectedTest: null,
    loading: false,
  } as RecommendedTestDrawerState,
  isDraft: false,
  company: 1,
  category: '',
  manageError: {},
  companies: [],
  variableDrawerOpen: false,
  questionDrawerOpen: false,
  responseDrawerOpen: false,
  variableToCreate: undefined,
  variableToEdit: undefined,
  questionToEdit: undefined,
  questionToCreate: undefined,
  responseToEdit: undefined,
  variableDeletionConfirmPopin: {
    open: false,
    title: '',
    content: '',
    handlePopinConfirm: undefined,
    handlePopinClose: undefined,
    data: undefined,
  },
  questionDeletionConfirmPopin: {
    open: false,
    title: '',
    content: '',
    handlePopinConfirm: undefined,
    handlePopinClose: undefined,
    data: undefined,
  },
  aglomerationsToCreate: [],
  aglomerationsToEdit: [],
  aglomerations: [],
  // aglomerations: [
  //   {
  //     id: 1,
  //     variables: [
  //       {
  //         id: 1,
  //         name: 'text 1',
  //         title: 'title 1',
  //       },
  //       {
  //         id: 2,
  //         name: 'text 2',
  //         title: 'title 2',
  //       },
  //     ],
  //     questions: [
  //       {
  //         id: 1,
  //         responses: [
  //           {
  //             id: 1,
  //             order: 1,
  //           },
  //           {
  //             id: 3,
  //             order: 2,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     id: 2,
  //     variables: [
  //       {
  //         id: 1,
  //         name: 'text 1',
  //         title: 'title 1',
  //       },
  //     ],
  //     questions: [
  //       {
  //         id: 1,
  //         responses: [
  //           {
  //             id: 1,
  //             order: 1,
  //           },
  //           {
  //             id: 3,
  //             order: 2,
  //           },
  //         ],
  //       },
  //       {
  //         id: 3,
  //         responses: [
  //           {
  //             id: 1,
  //             order: 1,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // ],
  variableAglomerationToEdit: undefined,
  questionAglomerationToCreate: undefined,
  questionAglomerationToEdit: undefined,
  responseAglomerationToEdit: undefined,
  variableAglomerationDrawerOpen: false,
  questionAglomerationDrawerOpen: false,
  responseAglomerationDrawerOpen: false,
  indexAglomerationEditing: null,
  idAglomerationSelected: undefined,
  toDeleteAglomerationsIds: [],
  toDeleteVariablesAglomerationIds: [],
  toDeleteQuestionsAglomerationIds: [],
  toDeleteResponsesAglomerationIds: [],
  refs: {},
  errors: {},
  loading: true,
};

export const AdminTestContext = createContext(initialState) as any;

export const CreateTestContextProvider = ({ children }: any) => {
  const [test, setAdminTest] = useState<any>(initialState);
  const [refetch, setRefetch] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);

  const { id }: any = useParams();
  const location = useLocation();

  const testTitleRef: any = useRef(null);
  const testTimeRef: any = useRef(null);
  const testImageRef: any = useRef(null);
  const testVisibilityRef: any = useRef(null);
  const testCategoryRef: any = useRef(null);
  const testVariablesRef: any = useRef(null);
  const testQuestionsRef: any = useRef(null);
  const testMinMaxValueRef: any = useRef(null);
  const testGlobalTimerRef: any = useRef(null);

  const refs = {
    testTitleRef,
    testImageRef,
    testTimeRef,
    testVisibilityRef,
    testCategoryRef,
    testVariablesRef,
    testQuestionsRef,
    testMinMaxValueRef,
    testGlobalTimerRef,
  };

  const token = getFromLS('userToken') || '';

  const updateTest = async (value: any) => {
    setAdminTest((state: any) => {
      return { ...state, ...value };
    });
  };

  const resetTest = () => {
    setAdminTest(initialState);
  };

  const refetchTest = () => {
    setRefetch(true);
  };

  const fetchCurrentTest = useCallback(async () => {
    try {
      setFetchLoading(true);
      const { data } = await TestService.getTestPopulated(token, id);
      if (data?.test?.id) {
        const toEditTest: any = {};
        toEditTest.test = {};
        toEditTest.test.id = data?.test?.id;
        toEditTest.test.title = data?.test?.title || '';

        toEditTest.test.description = data.test?.description || '';

        toEditTest.test.image = data.test?.image || '';
        toEditTest.test.thumbnail = data.test?.thumbnail || '';

        toEditTest.test.time = data.test?.time || '';
        toEditTest.test.useGlobalTimer = data.test?.useGlobalTimer || false;
        toEditTest.test.globalTimer = data.test?.globalTimer || '';

        const visibilityPermission = getVisibilityPermission(data.test?.visibilityPermission);

        const stockageMode = !data.test?.saveTestResult
          ? { value: 0, label: 'Données non-stockées' }
          : { value: 1, label: 'Données stockées' };
        const isAllEnterpriseSelected = data.test?.isAllEnterpriseSelected ?? false;
        const enterpriseSelected = getEnterpriseSelected(
          data.test?.companies,
          data.test?.isAllEnterpriseSelected
        );

        toEditTest.test.stockageMode = stockageMode;

        toEditTest.test.isAllEnterpriseSelected = isAllEnterpriseSelected;

        toEditTest.test.diagram = {
          id: data?.test?.diagram?.id,
          type: data?.test?.diagram?.type,
        };

        // Correction : mapping explicite du champ diagramTitle
        toEditTest.test.diagramTitle = data.test?.diagramTitle || '';
        toEditTest.test.univers = data.test?.univers || null;

        // default company is orient action with id = 1
        const company = data.test?.company?.id ? 1 : 0;
        toEditTest.company = company;

        const category = data.test?.category_test?.id || 0;
        toEditTest.category = category;

        const finalText: any = {};

        finalText.id = data.test?.finalText?.id ?? '';
        finalText.title = data.test?.finalText?.title ?? '';
        finalText.description = data.test?.finalText?.description ?? '';
        toEditTest.finalText = finalText;

        toEditTest.questions = data?.test?.questions || [];
        toEditTest.variables = data?.test?.variables || [];

        // Load recommended tests
        const recommendedTests = (data?.test?.recommendedTests || []).map(
          (test: any, index: number) => ({
            id: test.id,
            title: test.title,
            description: test.description,
            order: index,
          })
        );
        toEditTest.recommendedTests = recommendedTests;
        toEditTest.aglomerations = data?.test?.aglomerations;
        toEditTest.test.minValueAg = data?.test?.minValueAg;
        toEditTest.test.maxValueAg = data?.test?.maxValueAg;

        updateTest({
          ...toEditTest,
          visibilityPermission,
          stockageMode,
          enterpriseSelected,
          isAllEnterpriseSelected,
          isEdit: true,
          refs,
          loading: false,
          pageTitle: 'Modifier le test',
        });
      }
    } catch (error) {
      console.log('Error ', error);
    } finally {
      setRefetch(false);
      setFetchLoading(false);
    }
  }, [fetchLoading]);

  const fetchCompanies = useCallback(async () => {
    const companiesData = await Company.getCompanies(token);
    updateTest({ companies: companiesData?.data?.data?.filter((c: any) => c.id !== 1) });
  }, [token]);

  useEffect(() => {
    fetchCompanies();
    window.scroll(0, 0);
  }, [fetchCompanies]);

  useEffect(() => {
    if (location.pathname.includes('/modifier')) {
      fetchCurrentTest();
    } else {
      setAdminTest((state: any) => ({
        ...state,
        isEdit: false,
        refs,
        loading: false,
        pageTitle: 'Créer un test',
      }));
    }
  }, []);

  useEffect(() => {
    if (location.pathname.includes('/modifier') && refetch) {
      fetchCurrentTest();
    }
  }, [refetch]);

  const testAglomere = (data: any) => {
    return Object.values(
      data
        .flatMap(({ key, items }: any) => items.map((item: any) => ({ ...item, __groupKey: key })))
        .reduce((acc: any, item: any) => {
          const { id, name, order } = item.algomeration;
          if (!acc[id]) {
            acc[id] = { id, name, order };
            data.forEach(({ key }: any) => {
              acc[id][key] = [];
            });
          }
          acc[id][item.__groupKey].push(item);
          return acc;
        }, {})
    );
  };

  console.log('CONTEXT_VALUE', test);

  return (
    <AdminTestContext.Provider value={{ test, updateTest, resetTest, refetchTest, fetchLoading }}>
      {children}
    </AdminTestContext.Provider>
  );
};
